<template>
  <b-card>
    <b-card-title>Delete Account</b-card-title>
    <b-card-text>
      Permanently delete account and unsubscribe from emails.
      <br>
      <strong>Please note you will not be able to access any research after having done this.</strong>
      <br>
      Email communications from us are an important part of this, and therefore we regret it is not possible to unsubscribe from emails alone.
    </b-card-text>

    <b-form-checkbox
      v-model="confirmDeactivation"
      class="mb-2 cursor-pointer"
    >
      I confirm account deactivation
    </b-form-checkbox>

    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="danger"
      :disabled="!confirmDeactivation || deactivateLoading"
      @click="submitDeactivation"
    >
      <b-spinner
        v-if="deactivateLoading"
        small
      />
      <span v-else>Deactivate Account</span>
    </b-button>
  </b-card>
</template>

<script>
import {
  BButton, BCard, BCardTitle, BCardText, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BCard,
    BCardTitle,
    BCardText,
    BFormCheckbox,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      confirmDeactivation: false,
      deactivateLoading: false,
    }
  },
  methods: {
    submitDeactivation() {
      // Reset flags
      this.deactivateLoading = true

      this.$http
        .get('account.cfc', {
          params: {
            method: 'dounsubscribe',
          },
        })
        .then(response => {
          this.deactivateLoading = false

          if (response.data.success) {
            this.$bvToast.toast('Your account has been deactivated successfully. You will be logged out shortly.', {
              title: 'Account Deactivated',
              variant: 'success',
              solid: true,
            })
            // Redirect to logout or home page after a delay
            setTimeout(() => {
              window.location.href = '/logout'
            }, 2000)
          } else {
            this.$bvToast.toast('Your account could not be deactivated. Please try again', {
              title: 'Failed',
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(() => {
          this.deactivateLoading = false
          this.$bvToast.toast('An error occurred. Please try again', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>

<style scoped>
.cursor-pointer >>> .custom-control-label,
.cursor-pointer >>> .custom-control-input {
  cursor: pointer !important;
}
</style>
